<template>
  <div class="pokemon-entry-button text-center" disabled="disabled">
    <div v-if="statusEffect"  class="pokemon-entry-button__sprite" :style="spriteStyle" style="opacity: 0.75">
      <div class="pokemon-entry-button__lvl">{{ lvl }}</div>
    </div>

    <div v-if="!statusEffect"  class="pokemon-entry-button__sprite" :style="spriteStyle">
      <div class="pokemon-entry-button__lvl">{{ lvl }}</div>
    </div>

    <span v-if="isBuddy" class="pokemon-entry-button__teamslot-0">💗</span>

    <div v-if="statusEffect"
        style="position: absolute;top: 10px;bottom: 30px;left: 10px; right: 10px;background-size: contain;background-position: center;background-repeat: no-repeat;opacity: 1"
        :style="{ backgroundImage: 'url(' + require('@/assets/img/status_effects/' + statusEffect + '.svg') + ')' }">
    </div>

    <div v-if="publicBattleBanned"
        style="position: absolute;top: 45px;bottom: 30px;left: 10px; right: 10px;background-size: contain;background-position: center;background-repeat: no-repeat;opacity: 0.7">⛔
    </div>

    <div v-if="hpPercent !== null" class="pokemon-entry-button__health ml-auto mr-auto" :style="healthStyle"></div>

    {{ getPkmName()  }}<span v-if="isShiny">✨</span><span v-if="pokedexId > 100000">🎇</span><span v-else-if="specialVariant === 1">🎇</span><span v-if="specialVariant === 2">🏆</span>


  </div>
</template>

<script>
import {computed} from "@vue/reactivity";
import {imageUri} from "../../utils/settings";

export default {
  name: "PokemonEntryButton",
  props: {
    id: Number,
    pokedexId: Number,
    name: String,
    nickname: String,
    isShiny: Boolean,
    specialVariant: {
      type: Number,
      default: 0
    },
    publicBattleBanned: Boolean,
    lvl: [String, Number],
    hpPercent: Number,
    teamSlot: Number,
    isBuddy: Boolean,
    sellPrice: Number,
    avgIV: Number,
    statusEffect: String
  },
  setup(props) {
    const spriteStyle = computed(() => {
      return {
        backgroundImage: `url(${imageUri}static/pokedex/png-sprites/pokemon${props.isShiny ? "/shiny" : ""}/${props.pokedexId}.png)`
      };
    });

    const healthStyle = computed(() => {
      return {"--hp-percent": props.hpPercent + "%"};
    });

    function getPkmName() {
      if (props.nickname !== null && props.nickname !== undefined) {
        return props.nickname.substring(0, 10)
      }
      return props.name.substring(0, 10)
    }

    return {
      spriteStyle,
      healthStyle,
      getPkmName
    }
  }
}
</script>

<style lang="scss" scoped>
.pokemon-entry-button {
  padding-top: 68px;
  cursor: pointer;
  user-select: none;

  &__sprite {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    height: 68px;
    width: 68px;
    transition: all 100ms ease;
  }

  &:hover &__sprite {
    height: 76px;
    width: 76px;
    top: -4px;
  }

  &__lvl {
    position: absolute;
    color: #ffffff;
    background-color: rgba(23, 23, 23, 0.74);
    width: 19px;
    height: 19px;
    left: calc(50% + 12px);
    border-radius: 20px;
    font-size: small;
  }

  &__teamslot {
    position: absolute;
    left: 20%;
    bottom: 30px;
    font-size: small;
  }

  &__teamslot-0 {
    position: absolute;
    left: 10px;
    bottom: 30px;
    font-size: small;
  }

  &__health {
    --hp-percent: 0%;
    width: 40px;
    height: 3px;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.2) 0 0 2px;
    background: linear-gradient(to right, rgb(96, 210, 45) 0, rgb(168, 224, 99) var(--hp-percent), rgb(215, 42, 42) 00%, rgb(243, 84, 84) 100%)
  }
}
</style>